import apiClient from './client';
import { User } from '../types';

export interface CreateUserPayload {
  username: string;
  password: string;
  displayName?: string;
  email?: string;
  role: 'ADMIN' | 'OPERATOR' | 'VIEWER';
}

export interface UpdateUserPayload {
  displayName?: string;
  email?: string;
  role?: 'ADMIN' | 'OPERATOR' | 'VIEWER';
  status?: 'ACTIVE' | 'LOCKED' | 'DELETED';
  password?: string;
}

export const usersApi = {
  getAll: () =>
    apiClient.get<User[]>('/v1/users').then((r) => r.data),

  create: (data: CreateUserPayload) =>
    apiClient.post<User>('/v1/users', data).then((r) => r.data),

  update: (id: number, data: UpdateUserPayload) =>
    apiClient.put<User>(`/v1/users/${id}`, data).then((r) => r.data),

  delete: (id: number) =>
    apiClient.delete(`/v1/users/${id}`).then((r) => r.data),
};
